import React, { useState, useEffect } from "react";
import {
  Text,
  TouchableOpacity,
  View,
  Platform,
  TextInput,
  Image,
  StyleSheet,
  KeyboardAvoidingView,
  Keyboard,
  TouchableWithoutFeedback,
  Dimensions,
  ActivityIndicator,
} from "react-native";
import _ from "lodash";
import { connect } from "react-redux";
import PatientAvatarWithDetail from "../components/PatientAvatarWithDetail";
import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";
import Modal from "react-native-modal";
import { APP_BASE_URL } from "../helpers/storage";
import SearchableDropdown from "react-native-searchable-dropdown";
import { API } from "../helpers/axios";

const { width, height } = Dimensions.get("window");

const OrderMedicineScreen = (props) => {
  const [fulfillmentCenters, setFulfillmentCenters] = useState([]);
  const [phone, setPhone] = useState("");
  const [fulfillmentCenterId, setFulfillmentCenterId] = useState("");
  const [fulfillmentCenterName, setFulfillmentCenterName] = useState("");
  const [pharmacyName, setPharmacyName] = useState("");
  const [isWaitingResponse, setIsWaitingResponse] = useState(false);
  const [isPatientDataModalVisible, setIsPatientDataModalVisible] = useState(
    false
  );
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [isFailModalVisible, setIsFailModalVisible] = useState(false);
  const [hasErrorPhoneNumber, setHasErrorPhoneNumber] = useState(false);
  const [descErrorPhoneNumber, setDescErrorPhoneNumber] = useState("");
  const [hasErrorFulfillmentCenter, setHasErrorFulfillmentCenter] = useState(
    false
  );
  const [descErrorFulfillmentCenter, setDescErrorFulfillmentCenter] = useState(
    ""
  );

  useEffect(() => {
    var pharmacy = props.navigation.state.params.pharmacy;
    setPharmacyName(pharmacy.pharmacy_name);
    if (pharmacy.pharmacy_name === "Lifepack") {
      buildLifepackFulfillmentCenter(pharmacy.fulfillment_center);
    } else if (pharmacy.pharmacy_name === "Siloam") {
      buildSiloamFulfillmentCenter(pharmacy.fulfillment_center);
    } else {
    }
  }, []);

  useEffect(() => {
    var pharmacy = props.navigation.state.params.pharmacy;
    setPharmacyName(pharmacy.pharmacy_name);
    if (pharmacy.pharmacy_name === "Lifepack") {
      buildLifepackFulfillmentCenter(pharmacy.fulfillment_center);
    } else if (pharmacy.pharmacy_name === "Siloam") {
      buildSiloamFulfillmentCenter(pharmacy.fulfillment_center);
    } else {
    }
  }, []);

  const onBackButtonPressed = () => {
    props.navigation.navigate("PrescriptionDetail");
  };

  const onOrderNowButtonPressed = () => {
    var isPhoneValid = isPhoneNumberValid();
    var isFlfillmentCenterValid = isFulfillmentCenterValid();

    if (isPhoneValid && isFlfillmentCenterValid) {
      setIsPatientDataModalVisible(true);
    }
  };

  const isPhoneNumberValid = () => {
    var valid = false;
    const regex = /^(08\d{8,10})$|(\+62\d{9,11})$/;
    if (phone == "") {
      setHasErrorPhoneNumber(true);
      setDescErrorPhoneNumber("Nomor HP tidak boleh kosong");
    } else if (isNaN(phone)) {
      setHasErrorPhoneNumber(true);
      setDescErrorPhoneNumber("Nomor HP harus angka");
    } else if (regex.test(phone) === false) {
      setHasErrorPhoneNumber(true);
      setDescErrorPhoneNumber("Format nomor HP salah");
    } else {
      valid = true;
      setHasErrorPhoneNumber(false);
      setDescErrorPhoneNumber("");
    }
    return valid;
  };

  const isFulfillmentCenterValid = () => {
    var valid = false;
    var foundMatchFC = findFulfillmentCenter(fulfillmentCenterId);
    if (fulfillmentCenterId == "" || fulfillmentCenterName == "") {
      setHasErrorFulfillmentCenter(true);
      setDescErrorFulfillmentCenter("Lokasi tidak boleh kosong");
    } else if (foundMatchFC <= 0) {
      setHasErrorFulfillmentCenter(true);
      setDescErrorFulfillmentCenter("Lokasi tidak ditemukan");
    } else {
      valid = true;
      setHasErrorFulfillmentCenter(false);
      setDescErrorFulfillmentCenter("");
    }
    return valid;
  };

  const buildSiloamFulfillmentCenter = (fulfillmentCenters) => {
    var listFulfillmentCenters = [];
    _.each(fulfillmentCenters, (item) => {
      listFulfillmentCenters.push({
        id: item.id,
        name: item.name + " - " + item.city?.name ?? null,
      });
    });
    setFulfillmentCenters(listFulfillmentCenters);
  };

  const buildLifepackFulfillmentCenter = (fulfillmentCenters) => {
    var listFulfillmentCenters = [];
    _.each(fulfillmentCenters, (item) => {
      listFulfillmentCenters.push({
        id: item.id,
        name: item.name,
      });
    });
    setFulfillmentCenters(listFulfillmentCenters);
  };

  const onProcessOrderButtonPressed = () => {
    setIsPatientDataModalVisible(false);
    submitOrderPrescription();
  };

  const onSubmitOrderPrescriptionSuccess = () => {
    setIsSuccessModalVisible(true);
  };

  const onSubmitOrderPrescriptionFail = () => {
    setIsFailModalVisible(true);
  };

  const onRetrySubmitOrderPrescription = () => {
    setIsFailModalVisible(false);
    submitOrderPrescription();
  };

  const submitOrderPrescription = () => {
    setIsWaitingResponse(true);
    sendOrderPrescriptionToServer();
  };

  const sendOrderPrescriptionToServer = async () => {
    const { prescriptionId } = props.navigation.state.params;
    const payload = {
      phone: phone,
      fulfillment_center_id: fulfillmentCenterId,
    };

    try {
      const {
        data: { data: prescriptionOrder, status },
      } = await API.post(
        `${APP_BASE_URL}/v2/prescription/${prescriptionId}/order`,
        payload
      );

      if (prescriptionOrder) {
        if (status === "success") {
          setTimeout(() => {
            setIsWaitingResponse(false);
            onSubmitOrderPrescriptionSuccess();
          }, 350);
        } else {
          setTimeout(() => {
            setIsWaitingResponse(false);
            onSubmitOrderPrescriptionFail();
          }, 350);
        }
      }
    } catch (error) {
      setIsWaitingResponse(false);
      console.log(error?.response || error);
    }
  };

  const goDoubleBack = () => {
    setIsSuccessModalVisible(false);
    props.navigation.navigate("CustomerProfile");
  };

  const onPhoneTextChange = (phone) => {
    setPhone(phone);
    setDescErrorPhoneNumber("");
    setHasErrorPhoneNumber(false);
  };

  const onFulfillmentCenterSelected = (
    fulfillmentCenterId,
    fulfillmentCenterName
  ) => {
    setFulfillmentCenterName(fulfillmentCenterName);
    setFulfillmentCenterId(fulfillmentCenterId);
    setHasErrorFulfillmentCenter(false);
    setDescErrorFulfillmentCenter("");
  };

  const onFulfillmentCenterTextChange = (fulfillmentCenterName) => {
    setFulfillmentCenterName(fulfillmentCenterName);
    setHasErrorFulfillmentCenter(false);
    setDescErrorFulfillmentCenter("");
  };

  const findFulfillmentCenter = (fulfillmentCenterId) => {
    if (fulfillmentCenterId === "") {
      return [];
    }

    return fulfillmentCenters.filter(
      (fulfillmentCenter) =>
        fulfillmentCenter.id.search(fulfillmentCenterId) >= 0
    );
  };

  const closeVerificationModal = () => {
    setIsPatientDataModalVisible(false);
  };
  const closeSuccessModal = () => {
    setIsSuccessModalVisible(false);
  };
  const closeFailModal = () => {
    setIsFailModalVisible(false);
  };
  const closeLoadingModal = () => {
    setIsWaitingResponse(false);
  };

  return (
    <KeyboardAvoidingView behavior={"position"} keyboardVerticalOffset={50}>
      <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
        <View style={{ backgroundColor: props.themeColors.primary }}>
          {isPatientDataModalVisible ? (
            <Modal
              isVisible={true}
              backdropColor="#515151"
              useNativeDriver={true}
              onModalHide={closeVerificationModal}
              onDismiss={closeVerificationModal}
            >
              <View style={styles.containerTitleModal}>
                <Text style={styles.titleVerificationModal}>
                  Apakah Anda yakin data yang dimasukkan sudah benar?
                </Text>
                <Text style={styles.bodyVerificationModal}>
                  Dengan menyetujui untuk proses resep, Anda telah melakukan
                  pengecekan data pasien dan detail kontak untuk pengiriman.
                </Text>
                <View style={styles.containerListButtonsVerificationModal}>
                  <TouchableOpacity
                    onPress={() => {
                      setIsPatientDataModalVisible(false);
                    }}
                  >
                    <View
                      style={[
                        styles.buttonModal,
                        { backgroundColor: "#E64F4F", paddingHorizontal: 25 },
                      ]}
                    >
                      <Text style={styles.textButtonModal}>KEMBALI</Text>
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity onPress={onProcessOrderButtonPressed}>
                    <View
                      style={[
                        styles.buttonModal,
                        { backgroundColor: "#5DBE66", paddingHorizontal: 17 },
                      ]}
                    >
                      <Text style={styles.textButtonModal}>PROSES RESEP</Text>
                    </View>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
          ) : null}
          {isSuccessModalVisible ? (
            <Modal
              isVisible={true}
              backdropColor="#515151"
              useNativeDriver={true}
              onModalHide={closeSuccessModal}
              onDismiss={closeSuccessModal}
            >
              <View style={styles.containerSuccessOrderModal}>
                <Image
                  source={require("../assets/icons/tick.png")}
                  style={styles.imgSuccessOrderModal}
                />
                <Text style={styles.titleSuccessOrderModal}>
                  Permintaan Resep Berhasil Dikirim
                </Text>
                {pharmacyName === "Lifepack" ? (
                  <Text style={styles.textBodySuccessOrderModal}>
                    Tim Apoteker kami akan melakukan pengecekan dan
                    mengkonfirmasi melalui push notifikasi. Mohon untuk menunggu
                    beberapa menit.
                  </Text>
                ) : (
                  <Text style={styles.textBodySuccessOrderModal}>
                    Tim Apoteker kami akan melakukan pengecekan dan
                    mengkonfirmasi pesanan melalui telepon/SMS/Whatsapp.
                  </Text>
                )}
                <View style={styles.containerListButtonSuccessOrderModal}>
                  <TouchableOpacity onPress={goDoubleBack}>
                    <View
                      style={[
                        styles.buttonModal,
                        { backgroundColor: "#5DBE66", paddingHorizontal: 40 },
                      ]}
                    >
                      <Text style={styles.textButtonModal}>SELESAI</Text>
                    </View>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
          ) : null}
          {isFailModalVisible ? (
            <Modal
              isVisible={isFailModalVisible}
              backdropColor="#515151"
              useNativeDriver={true}
              onModalHide={closeFailModal}
              onDismiss={closeFailModal}
            >
              <View style={styles.containerFailOrderModal}>
                <Image
                  source={require("../assets/icons/fail.png")}
                  style={styles.imgFailOrderModal}
                />
                <Text style={styles.titleFailOrderModal}>
                  Permintaan Resep Gagal Dikirim
                </Text>
                <Text style={styles.textBodyFailOrderModal}>
                  Silahkan coba kembali dalam beberapa saat
                </Text>
                <View style={styles.containerListButtonsFailOrderModal}>
                  <TouchableOpacity
                    onPress={() => {
                      setIsFailModalVisible(false);
                    }}
                  >
                    <View
                      style={[
                        styles.buttonModal,
                        {
                          backgroundColor: "#E64F4F",
                          marginLeft: 10,
                          paddingHorizontal: 30,
                        },
                      ]}
                    >
                      <Text style={styles.textButtonModal}>KEMBALI</Text>
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity onPress={onRetrySubmitOrderPrescription}>
                    <View
                      style={[
                        styles.buttonModal,
                        {
                          backgroundColor: "#5DBE66",
                          marginRight: 10,
                          paddingHorizontal: 25,
                        },
                      ]}
                    >
                      <Text style={styles.textButtonModal}>COBA LAGI</Text>
                    </View>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
          ) : null}
          {isWaitingResponse ? (
            <Modal
              isVisible={true}
              backdropColor="#ffffff"
              useNativeDriver={true}
              onModalHide={closeLoadingModal}
              onDismiss={closeLoadingModal}
            >
              <View
                style={[
                  styles.containerTitleModal,
                  { backgroundColor: "rgba(0,0,0,0)", alignItems: "center" },
                ]}
              >
                <ActivityIndicator
                  size="large"
                  color={props.themeColors.primary}
                />
              </View>
            </Modal>
          ) : null}

          <View style={styles.header}>
            <PatientAvatarWithDetail
              cardNumber={props.navigation.state.params.cardNumber}
              fullName={props.navigation.state.params.customerName}
              gender={props.navigation.state.params.gender}
            />
            <TouchableOpacity
              style={{ marginStart: 20 }}
              onPress={() => scrollRef.scrollTo({ x: 0, y: 500 })}
            ></TouchableOpacity>
          </View>
          <View
            style={{
              backgroundColor: "#FFF",
              borderTopEndRadius:
                Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
              borderTopStartRadius:
                Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
            }}
          >
            {fulfillmentCenters.length <= 0 ? (
              <View style={{ paddingTop: height * 0.3, alignItems: "center" }}>
                <ActivityIndicator
                  size="large"
                  color={props.themeColors.primary}
                />
              </View>
            ) : (
              <View>
                <View style={styles.containerTitleOrderMedicine}>
                  <Text style={styles.textTitleOrderMedicine}>
                    PEMESANAN OBAT
                  </Text>
                </View>
                <View style={styles.containerBodyOrderMedicine}>
                  <View style={styles.containerInfo}>
                    <Text style={styles.textBodyOrderMedicine}>
                      Mohon untuk melengkapi data dibawah untuk kebutuhan
                      pengiriman obat dan pembayaran.
                    </Text>
                  </View>
                  <Text style={styles.textForm}>Nama Pasien</Text>
                  <Text
                    style={{ color: "#000", fontSize: 18, paddingVertical: 7 }}
                  >
                    {props.navigation.state.params.patientName}
                  </Text>
                  <Text style={styles.textForm}>Nomor Ponsel</Text>
                  <TextInput
                    style={styles.inputTextForm}
                    placeholder="e.g. 08XXXXXXXXX"
                    keyboardType={"phone-pad"}
                    onChangeText={(phone) => onPhoneTextChange(phone)}
                  />
                  {hasErrorPhoneNumber ? (
                    <View style={{ paddingTop: 5 }}>
                      <Text style={styles.error}>{descErrorPhoneNumber}</Text>
                    </View>
                  ) : null}
                  <Text style={styles.textForm}>Lokasi</Text>
                  <SearchableDropdown
                    onTextChange={(text) => onFulfillmentCenterTextChange(text)}
                    onItemSelect={(item) =>
                      onFulfillmentCenterSelected(item["id"], item["name"])
                    }
                    containerStyle={styles.containerDropDown}
                    itemStyle={styles.itemDropDown}
                    itemTextStyle={styles.itemTextStyleDropDown}
                    itemsContainerStyle={{ maxHeight: 240 }}
                    items={fulfillmentCenters}
                    textInputProps={{
                      placeholder: "e.g DKI JAKARTA",
                      underlineColorAndroid: "transparent",
                      style: {
                        padding: 5,
                        borderWidth: 1,
                        borderColor: "#ccc",
                        borderRadius: 10,
                        fontSize: 17,
                        height: 40,
                      },
                    }}
                    resetValue={false}
                    underlineColorAndroid="transparent"
                  />
                  {hasErrorFulfillmentCenter ? (
                    <View style={{ paddingTop: 5 }}>
                      <Text style={styles.error}>
                        {descErrorFulfillmentCenter}
                      </Text>
                    </View>
                  ) : null}
                  {pharmacyName === "Siloam" ? (
                    <View style={{ paddingTop: 20 }}>
                      <Text
                        style={{
                          color: staticColors.grey,
                          fontSize: 15,
                          textAlign: "justify",
                        }}
                      >
                        Untuk sementara hanya melayani pengantaran pada
                        kota-kota diatas. Untuk daerah lainnya Anda dapat
                        download resep dan menebusnya di apotek yang bekerja
                        sama dengan Mandiri InHealth
                      </Text>
                    </View>
                  ) : null}
                </View>
                <View style={styles.containerListButtonOrderMedicine}>
                  <TouchableOpacity
                    onPress={onBackButtonPressed}
                    style={{ alignSelf: "center" }}
                  >
                    <View style={styles.buttonBackOrderMedicine}>
                      <Text style={styles.textButtonOrderMedicine}>
                        KEMBALI
                      </Text>
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={onOrderNowButtonPressed}
                    style={{ alignSelf: "center" }}
                  >
                    <View style={styles.buttonOrderMedicine}>
                      <Text style={styles.textButtonOrderMedicine}>
                        PESAN SEKARANG
                      </Text>
                    </View>
                  </TouchableOpacity>
                </View>
              </View>
            )}
          </View>
        </View>
      </TouchableWithoutFeedback>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 20,
  },
  containerTitleModal: {
    backgroundColor: "#FFFFFF",
    borderRadius: 40,
    padding: 30,
  },
  titleVerificationModal: {
    color: "#808080",
    fontSize: 20,
    ...fonts.bold,
    textAlign: "center",
  },
  bodyVerificationModal: {
    color: "#808080",
    fontSize: 17,
    textAlign: "center",
    lineHeight: 20,
    marginTop: 30,
    marginVertical: 30,
  },
  containerListButtonsVerificationModal: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  buttonModal: {
    borderRadius: 20,
    paddingVertical: 10,
  },
  textButtonModal: {
    color: "#FFFFFF",
    fontSize: 15,
    ...fonts.bold,
  },
  containerSuccessOrderModal: {
    backgroundColor: "#FFFFFF",
    borderRadius: 40,
    padding: 15,
  },
  imgSuccessOrderModal: {
    width: 100,
    height: 100,
    alignSelf: "center",
    marginTop: 20,
    marginBottom: 10,
  },
  titleSuccessOrderModal: {
    color: "#808080",
    fontSize: 18,
    ...fonts.bold,
    textAlign: "center",
  },
  textBodySuccessOrderModal: {
    color: "#808080",
    fontSize: 16,
    textAlign: "center",
    marginTop: 10,
  },
  containerListButtonSuccessOrderModal: {
    alignSelf: "center",
    marginVertical: 15,
  },
  containerFailOrderModal: {
    backgroundColor: "#FFFFFF",
    borderRadius: 40,
    padding: 15,
  },
  imgFailOrderModal: {
    width: 100,
    height: 100,
    alignSelf: "center",
    marginTop: 20,
    marginBottom: 10,
  },
  titleFailOrderModal: {
    color: "#808080",
    fontSize: 20,
    ...fonts.bold,
    textAlign: "center",
  },
  textBodyFailOrderModal: {
    color: "#808080",
    fontSize: 16,
    textAlign: "center",
  },
  containerListButtonsFailOrderModal: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 15,
  },
  containerTitleOrderMedicine: {
    paddingTop: 10,
    alignSelf: "center",
  },
  textTitleOrderMedicine: {
    fontSize: 24,
    ...fonts.bold,
    color: "#000",
    width: 250,
    textAlign: "center",
    paddingVertical: 7,
  },
  containerBodyOrderMedicine: {
    paddingVertical: 7,
    marginHorizontal: 20,
  },
  containerInfo: {
    paddingBottom: 5,
  },
  textBodyOrderMedicine: {
    fontSize: 18,
    color: "#000",
    paddingVertical: 5,
    textAlign: "justify",
    lineHeight: 20,
    letterSpacing: 0.5,
  },
  textForm: {
    fontSize: 18,
    ...fonts.bold,
    color: "#000",
    width: 250,
    paddingVertical: 7,
    marginTop: 10,
  },
  inputTextForm: {
    padding: 5,
    height: 40,
    borderColor: "gray",
    borderWidth: 1,
    textAlignVertical: "top",
    fontSize: 18,
    borderRadius: 10,
    textTransform: "uppercase",
  },
  containerListButtonOrderMedicine: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 30,
  },
  buttonBackOrderMedicine: {
    borderRadius: 30,
    alignSelf: "flex-start",
    backgroundColor: staticColors.red,
    paddingVertical: 12,
    paddingHorizontal: 46,
    marginLeft: 20,
  },
  buttonOrderMedicine: {
    borderRadius: 30,
    alignSelf: "flex-start",
    backgroundColor: staticColors.forestFern,
    paddingVertical: 12,
    paddingHorizontal: 20,
    marginRight: 20,
  },
  textButtonOrderMedicine: {
    ...fonts.bold,
    color: "#FFF",
    textAlign: "center",
  },
  error: {
    color: "red",
    fontSize: 15,
  },
  containerDropDown: {
    borderColor: "gray",
    borderWidth: 1,
    fontSize: 18,
    borderRadius: 10,
    textTransform: "uppercase",
  },
  itemDropDown: {
    padding: 10,
    marginTop: 2,
    backgroundColor: "#FAF9F8",
    borderColor: "#bbb",
    borderRadius: 10,
    borderWidth: 1,
  },
  itemTextStyleDropDown: {
    color: "#222",
    fontSize: 18,
  },
});
export default connect((state) => ({
  themeColors: state.themeColors,
}))(OrderMedicineScreen);
